import { render } from "./BotEditForm.vue?vue&type=template&id=114d260d"
import script from "./BotEditForm.vue?vue&type=script&lang=js"
export * from "./BotEditForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__